import { useEffect, useState, useContext } from "react";
import Repo from "../../Utility/Repo";
import { useLocation } from "react-router-dom";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { TokenContext } from "../../Components/TokenContext";
import Loader from "../../Components/Loader";
import ModalComponent from "../../Components/ModalComponent";
import { Input } from "design-react-kit";
import UploadFile from "../../Components/UploadFile";
import moment from "moment";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import "dayjs/locale/it";
import * as XLSX from "xlsx";
import { useCookies } from "react-cookie";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ViewAlunniMensa = (props) => {
  dayjs.locale("it");
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalUpload, setShowModalUpload] = useState(false);
  const [showModalDel, setShowModalDel] = useState(false);
  const [showModalModify, setShowModalModify] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [udoConsentite, setUdoConsentite] = useState([]);
  const [versionsToShow, setVersionsToShow] = useState(null);
  const [uploadUsersFile, setUploadUsersFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState(false);
  const [versionName, setVersionName] = useState("");
  const [versionNameModify, setVersionNameModify] = useState("");
  const [openDettagli, setOpenDettagli] = useState({});
  let query = useQuery();
  const apiToken = useContext(TokenContext);
  const [cookies] = useCookies(["user_profile"]);
  const [listAnnouncementId, setListAnnouncementId] = useState();
  const [localAnnouncementId, setLocalAnnouncementId] = useState();
  const [loading, setLoading] = useState(false);
  const [userSubscriptions, setUserSubscriptions] = useState();
  const [userSubscriptionsFiltered, setUserSubscriptionsFiltered] = useState(
    {},
  );

  const [classi, setClassi] = useState();
  const [selectedClasse, setSelectedClasse] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedDateStart, setSelectedDateStart] = useState(
    moment().startOf("day"),
  );
  const [selectedDateEnd, setSelectedDateEnd] = useState(
    moment().startOf("day"),
  );

  const handleCreateVersion = () => {
    setLoading(true);
    Repo.postAddScuolaVersione(apiToken, null, versionName)
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handleUploadAlunni = () => {
    setLoading(true);
    Repo.postUploadAlunni(apiToken, localAnnouncementId, uploadUsersFile)
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handleUpdateVersion = () => {
    setLoading(true);
    Repo.postAddScuolaVersione(apiToken, localAnnouncementId, versionNameModify)
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handleDeleteVersion = () => {
    setLoading(true);
    Repo.delScuolaVersione(apiToken, localAnnouncementId)
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const resetChoose = () => {
    setUserSubscriptionsFiltered(userSubscriptions);
  };

  useEffect(() => {
    setLoading(true);
    if (props.isUser) {
      Promise.all([
        Repo.getScuolaVersioni(apiToken),
        Repo.getListaScuoleOperatori(apiToken),
      ])
        .then(async ([versionsRes, scuoleRes]) => {
          const allVersions = versionsRes.data || [];
          const cf = cookies.user_profile?.FiscalCode || "";
          const record = (scuoleRes.data || []).find(
            (op) => op.codiceFiscale?.toLowerCase() === cf.toLowerCase(),
          );
          const udos = record?.udoList
            ? record.udoList
                .split("/;/")
                .map((s) => s.trim())
                .filter(Boolean)
            : [];
          setUdoConsentite(udos);
          setListAnnouncementId(allVersions);
          if (udos.length === 0 || allVersions.length === 0) {
            setVersionsToShow([]);
            setLoading(false);
            return;
          }
          const classiResults = await Promise.all(
            allVersions.map((v) =>
              Repo.getScuolaVersioneIscrizioni(apiToken, v.id)
                .then((r) => ({
                  id: v.id,
                  classi: r.data.classiUnivoche || [],
                }))
                .catch(() => ({ id: v.id, classi: [] })),
            ),
          );
          const allowed = allVersions.filter((v) => {
            const res = classiResults.find((r) => r.id === v.id);
            return res?.classi.some((c) => udos.includes(c));
          });
          setVersionsToShow(allowed);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } else {
      Repo.getScuolaVersioni(apiToken)
        .then((response) => {
          setListAnnouncementId(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    }
  }, []);

  const last7Days = Array.from({ length: 7 }, (_, idx) =>
    moment()
      .startOf("day")
      .subtract(6 - idx, "days"),
  );

  const isPresenteInData = (alunno, dataStr) => {
    const presenze = Array.isArray(alunno?.scuolaMinorePresenze)
      ? alunno.scuolaMinorePresenze
      : [];
    return presenze.some((x) => x?.data === dataStr);
  };

  useEffect(() => {
    if (
      !props.isUser &&
      Array.isArray(listAnnouncementId) &&
      listAnnouncementId.length === 1 &&
      !localAnnouncementId
    ) {
      setLocalAnnouncementId(listAnnouncementId[0].id);
    }
  }, [listAnnouncementId, localAnnouncementId, props.isUser]);

  const InserisciPresenze = () => {
    const dataStr = formatDate(selectedDate);
    const utentiNonFiltrati = userSubscriptions.filter((a) => {
      return a.udo !== selectedClasse;
    });
    const utentiPrsentiIds = Array.isArray(userSubscriptionsFiltered)
      ? [
          ...userSubscriptionsFiltered
            .filter(
              (alunno) =>
                Array.isArray(alunno.scuolaMinorePresenze) &&
                alunno.scuolaMinorePresenze.some((x) => x.data === dataStr),
            )
            .map((alunno) => alunno.id),
          ...utentiNonFiltrati
            .filter(
              (alunno) =>
                Array.isArray(alunno.scuolaMinorePresenze) &&
                alunno.scuolaMinorePresenze.some((x) => x.data === dataStr),
            )
            .map((alunno) => alunno.id),
        ]
      : [];

    Repo.postPresenzeMensa(
      apiToken,
      localAnnouncementId,
      utentiPrsentiIds,
      dataStr,
    )
      .then((response) => {
        setHasUnsavedChanges(false);
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (
      !props.isUser &&
      Array.isArray(listAnnouncementId) &&
      listAnnouncementId.length === 1 &&
      !localAnnouncementId
    ) {
      setLocalAnnouncementId(listAnnouncementId[0].id);
    }
  }, [listAnnouncementId, localAnnouncementId, props.isUser]);

  useEffect(() => {
    if (
      props.isUser &&
      Array.isArray(versionsToShow) &&
      versionsToShow.length === 1 &&
      !localAnnouncementId
    ) {
      setLocalAnnouncementId(versionsToShow[0].id);
    }
  }, [versionsToShow, localAnnouncementId, props.isUser]);

  useEffect(() => {
    if (localAnnouncementId) {
      setHasUnsavedChanges(false);
      setLoading(true);
      Repo.getScuolaVersioneIscrizioni(apiToken, localAnnouncementId)
        .then((response) => {
          setLoading(false);
          const allStudents = response.data.versione.scuolaMinori;
          const allClassi = response.data.classiUnivoche;
          if (props.isUser && udoConsentite.length > 0) {
            const filteredStudents = allStudents.filter((a) =>
              udoConsentite.includes(a.udo),
            );
            setUserSubscriptions(filteredStudents);
            setUserSubscriptionsFiltered(filteredStudents);
            setClassi(
              (allClassi || []).filter((c) => udoConsentite.includes(c)),
            );
          } else {
            setUserSubscriptions(allStudents);
            setUserSubscriptionsFiltered(allStudents);
            setClassi(allClassi);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    }
  }, [localAnnouncementId, udoConsentite]);

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    if (selectedClasse) {
      setUserSubscriptionsFiltered(
        userSubscriptions.filter((a) => {
          return a.udo === selectedClasse;
        }),
      );
    } else {
      setUserSubscriptionsFiltered(userSubscriptions);
    }
  }, [selectedClasse, userSubscriptions]);

  const handleCheckAll = (seleziona) => {
    const dataStr = formatDate(selectedDate);
    setUserSubscriptionsFiltered((prev) =>
      prev?.map((a) => {
        if (userSubscriptionsFiltered.includes(a)) {
          let presenze = Array.isArray(a.scuolaMinorePresenze)
            ? [...a.scuolaMinorePresenze]
            : [];
          const isPresent = presenze.some((x) => x.data === dataStr);
          if (seleziona && !isPresent) {
            presenze.push({ data: dataStr });
          } else if (!seleziona && isPresent) {
            presenze = presenze.filter((d) => d.data !== dataStr);
          }
          return {
            ...a,
            scuolaMinorePresenze: presenze,
          };
        }
        return a;
      }),
    );
    setHasUnsavedChanges(true);
  };

  const handleCheck = (alunno) => {
    const dataStr = formatDate(selectedDate);
    let presenze = Array.isArray(alunno.scuolaMinorePresenze)
      ? [...alunno.scuolaMinorePresenze]
      : [];
    const isPresent = presenze.some((x) => x.data === dataStr);
    if (!isPresent) {
      presenze.push({ data: dataStr });
    } else {
      presenze = presenze.filter((d) => d.data !== dataStr);
    }
    setUserSubscriptionsFiltered((prev) =>
      prev?.map((a) =>
        a === alunno
          ? {
              ...a,
              scuolaMinorePresenze: presenze,
            }
          : a,
      ),
    );
    setHasUnsavedChanges(true);
  };

  const presenzeCount = Array.isArray(userSubscriptionsFiltered)
    ? userSubscriptionsFiltered.reduce((acc, alunno) => {
        if (Array.isArray(alunno.scuolaMinorePresenze)) {
          const presenzeNelRange = alunno.scuolaMinorePresenze.filter((x) => {
            const d = moment(x.data, "DD/MM/YYYY");
            return (
              d.isSameOrAfter(moment(selectedDateStart)) &&
              d.isSameOrBefore(moment(selectedDateEnd))
            );
          });
          return acc + presenzeNelRange.length;
        }
        return acc;
      }, 0)
    : 0;

  const assenzeCount = Array.isArray(userSubscriptionsFiltered)
    ? (() => {
        const numDays =
          moment(selectedDateEnd).diff(moment(selectedDateStart), "days") + 1;
        const totalSlots = userSubscriptionsFiltered.length * numDays;
        return Math.max(0, totalSlots - presenzeCount);
      })()
    : 0;

  const isChecked = (alunno) =>
    Array.isArray(alunno.scuolaMinorePresenze) &&
    alunno.scuolaMinorePresenze.some(
      (x) => formatDate(selectedDate) === x.data,
    );

  const handleExportExcel = () => {
    const dataStr = formatDate(selectedDate);
    const rows = (
      Array.isArray(userSubscriptionsFiltered) ? userSubscriptionsFiltered : []
    ).map((alunno) => ({
      Cognome: alunno.cognome || "",
      Nome: alunno.nome || "",
      Classe: alunno.udo || "",
      Email: alunno.email || "",
      Telefono: alunno.telefono || "",
      Presenza:
        Array.isArray(alunno.scuolaMinorePresenze) &&
        alunno.scuolaMinorePresenze.some((x) => x.data === dataStr)
          ? "SI"
          : "NO",
    }));
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Presenze");
    XLSX.writeFile(
      workbook,
      `presenze_mensa_${dataStr.replace(/\//g, "-")}.xlsx`,
    );
  };

  useEffect(() => {
    setSelectedDateStart(moment(selectedDate).startOf("day"));
    setSelectedDateEnd(moment(selectedDate).startOf("day"));
    setHasUnsavedChanges(false);
  }, [selectedDate]);

  const [weekStart, setWeekStart] = useState(() =>
    dayjs(new Date()).subtract(7, "day").startOf("week"),
  );

  const HorizontalCalendar = ({ selectedDate, setSelectedDate }) => {
    const selected = dayjs(selectedDate);

    const days = Array.from({ length: 21 }, (_, i) => weekStart.add(i, "day"));
    const monthYearLabel = weekStart.format("MMMM YYYY");

    return (
      <div>
        <div className="d-flex align-items-center justify-content-between mb-2 bg-light">
          <button
            type="button"
            className="btn btn-xs btn-outline-primary bg-white"
            onClick={() => setWeekStart((prev) => prev.subtract(7, "day"))}
            aria-label="Settimana precedente"
          >
            <svg className="icon icon-primary">
              <use href={`${iconSprite}#it-chevron-left`} />
            </svg>
          </button>

          <div className="text-center vm-calendar-month-label">
            <strong className="vm-calendar-month-text">{monthYearLabel}</strong>
          </div>

          <button
            type="button"
            className="btn btn-xs btn-outline-primary bg-white"
            onClick={() => setWeekStart((prev) => prev.add(7, "day"))}
            aria-label="Settimana successiva"
          >
            <svg className="icon icon-primary">
              <use href={`${iconSprite}#it-chevron-right`} />
            </svg>
          </button>
        </div>

        <div className="d-flex align-items-center justify-content-center">
          {days.map((day) => {
            const isSelected = day.isSame(selected, "day");

            return (
              <div
                key={day.format("YYYY-MM-DD")}
                onClick={() => setSelectedDate(day.toDate())}
                className={`p-2 mx-1 text-center vm-calendar-day ${
                  isSelected ? "bg-primary text-white" : ""
                }`}
              >
                <div className="vm-calendar-day-name">{day.format("ddd")}</div>
                <div>{day.format("D")}</div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderDettagli = (dettagli) => {
    if (!dettagli) return null;
    let obj = dettagli;
    if (typeof dettagli === "string") {
      try {
        obj = JSON.parse(dettagli);
      } catch {
        return <span>{dettagli}</span>;
      }
    }
    if (typeof obj !== "object") return <span>{dettagli}</span>;
    return (
      <div className="row">
        {Object.entries(obj).map(([label, valore]) => (
          <div key={label} className="col-4">
            <span className="vm-dettagli-entry">
              <strong>{label}:</strong> {valore}
            </span>
          </div>
        ))}
      </div>
    );
  };

  const toggleDettagli = (key) => {
    setOpenDettagli((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const displayVersions = props.isUser
    ? (versionsToShow ?? [])
    : listAnnouncementId;

  return (
    <>
      <div>
        {props.isOperator && (
          <div className="bg-light pt-3 px-5 rounded mb-3">
            <h1>Gestione responsabili</h1>
            <div className="row">
              <div className="col-7">
                Clicca sul pulsante per aggiungere, modificare o eliminare i
                profili e associare a ciascun responsabile la scuola di
                competenza
              </div>
              <div className="col-lg-4 offset-1 text-center">
                <Link
                  to="/calendario/gestione_responsabili"
                  className="btn btn-primary w-100 mb-5 px-4"
                >
                  <svg className="icon icon-white mr-2">
                    <use href={`${iconSprite}#it-user`} />
                  </svg>
                  Gestione Responsabili
                </Link>
              </div>
            </div>
          </div>
        )}
        <h1>Elenco presenze odierno</h1>
        <div className="clearfix col-lg-12 py-lg-2">
          <p>
            Visualizza l’elenco completo degli studenti previsti per la
            giornata, con la possibilità di filtrare per scuola e di selezionare
            gli studenti presenti.
            <br /> Per ogni studente è possibile visualizzare ulteriori dettagli
            cliccando sull’apposita icona.
          </p>
        </div>
        {displayVersions?.length > 0 ? (
          <div className="mb-4">
            <div className="row">
              <div className="col-6">
                <h4>Seleziona versione:</h4>
                <div className="row">
                  <div className="col-9">
                    <select
                      id="announcementSelect"
                      className="form-control border"
                      value={localAnnouncementId || ""}
                      onChange={(e) => setLocalAnnouncementId(e.target.value)}
                    >
                      {displayVersions?.length > 1 && (
                        <option value="">-- Seleziona --</option>
                      )}
                      {displayVersions?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                  {localAnnouncementId && props.isOperator && (
                    <>
                      <div className="col-1">
                        <button
                          className="btn btn-xs btn-outline-primary"
                          type="button"
                          data-toggle="tooltip"
                          data-placement="top"
                          onClick={() => {
                            setShowModalModify(true);
                            setVersionNameModify(
                              listAnnouncementId?.filter(
                                (item) => item.id === localAnnouncementId,
                              )[0]?.nome,
                            );
                          }}
                        >
                          <svg className="icon icon-primary">
                            <use href={`${iconSprite}#it-pencil`} />
                          </svg>
                        </button>
                      </div>
                      <div className="col-1">
                        <button
                          className="btn btn-xs btn-outline-danger"
                          type="button"
                          data-toggle="tooltip"
                          data-placement="top"
                          onClick={() => setShowModalDel(true)}
                        >
                          <svg className="icon icon-danger">
                            <use href={`${iconSprite}#it-delete`} />
                          </svg>
                        </button>
                      </div>
                    </>
                  )}
                </div>{" "}
                {props.isOperator && (
                  <>
                    <button
                      className="btn btn-outline-primary px-3 ml-1 mt-4"
                      type="button"
                      data-toggle="tooltip"
                      data-placement="top"
                      onClick={() => setShowModalAdd(true)}
                    >
                      Aggiungi versione
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-plus`} />
                      </svg>
                    </button>
                    {localAnnouncementId && (
                      <button
                        className="btn btn-outline-primary px-3 ml-1 ml-5 mt-4"
                        type="button"
                        data-toggle="tooltip"
                        data-placement="top"
                        onClick={() => setShowModalUpload(true)}
                      >
                        Carica alunni
                        <svg className="icon icon-primary">
                          <use href={`${iconSprite}#it-upload`} />
                        </svg>
                      </button>
                    )}
                  </>
                )}
              </div>
              <div className="col-6 text-right">
                {localAnnouncementId && (
                  <div className="card-body p-0">
                    <div className="row d-flex justify-content-center">
                      <div className="col-2"></div>
                      <div className="col-8">
                        <div className="card shadow text-center">
                          <div className="card-body py-2 px-3">
                            <span className="font-weight-bold">
                              Report presenze
                            </span>
                            <div
                              className="mt-2 d-flex justify-content-center"
                              style={{ gap: "1rem" }}
                            >
                              <div className="text-center">
                                <div className="small text-muted mb-1">
                                  Presenti
                                </div>
                                <span className="badge badge-pill badge-success vm-presenze-badge">
                                  {presenzeCount}
                                </span>
                              </div>
                              <div className="text-center">
                                <div className="small text-muted mb-1">
                                  Assenti
                                </div>
                                <span className="badge badge-pill badge-danger vm-presenze-badge">
                                  {assenzeCount}
                                </span>
                              </div>
                            </div>
                            <div className="row mt-5">
                              <div className="col-6">
                                <Input
                                  id="start"
                                  label="Data di Inizio"
                                  type="date"
                                  placeholder="gg/mm/aaaa"
                                  value={moment(selectedDateStart, "DD/MM/YYYY")
                                    .format("YYYY-MM-DD")
                                    .toString()}
                                  onChange={(e) =>
                                    setSelectedDateStart(moment(e.target.value))
                                  }
                                />
                              </div>
                              <div className="col-6">
                                <Input
                                  id="end"
                                  label="Data di Fine"
                                  type="date"
                                  placeholder="gg/mm/aaaa"
                                  value={moment(selectedDateEnd, "DD/MM/YYYY")
                                    .format("YYYY-MM-DD")
                                    .toString()}
                                  onChange={(e) =>
                                    setSelectedDateEnd(moment(e.target.value))
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {localAnnouncementId && (
              <>
                {userSubscriptions?.length > 0 ? (
                  <div className="mt-4">
                    <div className="container">
                      <div className="cmp-info-button-card radio-card mt-4">
                        <div className="card no-after p-3 p-lg-4">
                          {Array.isArray(userSubscriptionsFiltered) &&
                            userSubscriptionsFiltered.length > 0 && (
                              <div className="mt-4">
                                <div className="row">
                                  <div className="col-6">
                                    <h4>Seleziona alunni presenti:</h4>
                                    {classi && (
                                      <div className="mb-3">
                                        <label htmlFor="classeSelect">
                                          <strong>Filtra per scuola</strong>
                                        </label>
                                        <select
                                          id="classeSelect"
                                          className="form-control border"
                                          value={selectedClasse}
                                          onChange={(e) => (
                                            setSelectedClasse(e.target.value),
                                            resetChoose()
                                          )}
                                        >
                                          <option value="">
                                            Tutte le scuole
                                          </option>
                                          {classi.map((c) => (
                                            <option key={c} value={c}>
                                              {c}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-6 text-right">
                                    <div className="mb-4">
                                      <button
                                        className="btn btn-outline-primary btn-sm mr-2"
                                        type="button"
                                        onClick={() => handleCheckAll(true)}
                                      >
                                        Seleziona tutti
                                      </button>
                                      <button
                                        className="btn btn-outline-danger btn-sm"
                                        type="button"
                                        onClick={() => handleCheckAll(false)}
                                      >
                                        Deseleziona tutti
                                      </button>
                                      <button
                                        className="btn btn-outline-success btn-sm ml-2"
                                        type="button"
                                        onClick={handleExportExcel}
                                      >
                                        <svg className="icon icon-success icon-sm mr-1">
                                          <use
                                            href={`${iconSprite}#it-download`}
                                          />
                                        </svg>
                                        Esporta Excel
                                      </button>
                                    </div>
                                    Alunni trovati:{" "}
                                    <strong className="pr-3">
                                      {userSubscriptionsFiltered.length}
                                    </strong>
                                    <button
                                      className={`btn btn-sm ml-2 ${hasUnsavedChanges ? "btn-warning" : "btn-primary"}`}
                                      onClick={InserisciPresenze}
                                    >
                                      <svg className="icon icon-white icon-sm mr-1">
                                        <use
                                          href={`${iconSprite}#it-check-circle`}
                                        />
                                      </svg>
                                      <span className="text-white">
                                        Aggiorna Presenze
                                      </span>
                                    </button>
                                  </div>
                                </div>

                                <HorizontalCalendar
                                  selectedDate={selectedDate}
                                  setSelectedDate={setSelectedDate}
                                />
                                <ul className="list-unstyled">
                                  <div className="row mt-3">
                                    <div className="col-6 mb-2">
                                      <b>Cognome e Nome</b>
                                    </div>
                                    <div className="col-2 mb-2 text-center">
                                      <b>Presenza</b>
                                    </div>
                                    <div className="col-4 text-center pr-4">
                                      <b>
                                        Ultime 7 presenze <br />
                                        (dal {last7Days?.[0]?.format(
                                          "DD/MM",
                                        )}{" "}
                                        al{" "}
                                        {last7Days?.[
                                          last7Days.length - 1
                                        ]?.format("DD/MM")}
                                        )
                                      </b>
                                    </div>
                                  </div>
                                  {userSubscriptionsFiltered.map((alunno) => (
                                    <li key={alunno.id} className="mb-2">
                                      <div className="row">
                                        <div className="col-6">
                                          <button
                                            className="btn btn-link p-0"
                                            type="button"
                                            onClick={() =>
                                              toggleDettagli(alunno.id)
                                            }
                                            aria-expanded={
                                              !!openDettagli[alunno.id]
                                            }
                                            aria-controls={`collapseDettagli-${alunno.id}`}
                                          >
                                            <svg className="icon icon-primary">
                                              <use
                                                href={`${iconSprite}#it-expand`}
                                              />
                                            </svg>
                                          </button>
                                          <span
                                            className={
                                              Array.isArray(
                                                alunno.scuolaMinorePresenze,
                                              ) &&
                                              alunno.scuolaMinorePresenze.some(
                                                (x) =>
                                                  formatDate(selectedDate) ===
                                                  x.data,
                                              )
                                                ? "text-green"
                                                : "text-danger"
                                            }
                                          >
                                            {alunno.cognome} {alunno.nome}
                                          </span>{" "}
                                        </div>
                                        <div className="col-2">
                                          <div
                                            className={`row col-4 offset-4 custom-switch-pill ${
                                              isChecked(alunno) ? "active" : ""
                                            }`}
                                            onClick={() => handleCheck(alunno)}
                                          >
                                            <div className="switch-thumb"></div>
                                            <span className="label-no ml-n1">
                                              NO
                                            </span>
                                            <span className="label-si">SI</span>
                                          </div>
                                        </div>
                                        <div className="col-4 text-center">
                                          {last7Days.map((d, idx) => {
                                            const dataStr =
                                              d.format("DD/MM/YYYY");
                                            const presente = isPresenteInData(
                                              alunno,
                                              dataStr,
                                            );
                                            const isLast =
                                              idx === last7Days.length - 1;
                                            const color = presente
                                              ? "#1fa84f"
                                              : "#dc3545";
                                            return (
                                              <span
                                                key={dataStr + idx}
                                                className="mr-2 vm-presenza-dot"
                                                style={{
                                                  backgroundColor: color,
                                                  boxShadow: isLast
                                                    ? `0 0 0 3px ${color}`
                                                    : undefined,
                                                }}
                                                title={
                                                  (presente
                                                    ? "Presente "
                                                    : "Assente ") + dataStr
                                                }
                                              >
                                                {presente ? "✓" : "✗"}
                                              </span>
                                            );
                                          })}
                                        </div>
                                        <div className="col-12">
                                          {openDettagli[alunno.id] && (
                                            <div className="mt-2">
                                              {renderDettagli(alunno.dettagli)}
                                              <div className="row">
                                                <div className="col-4">
                                                  <strong>Classe </strong>
                                                  {alunno.udo}{" "}
                                                </div>
                                                <div className="col-4">
                                                  <strong>Email </strong>
                                                  {alunno.email}
                                                </div>
                                                <div className="col-4">
                                                  <strong>Telefono </strong>
                                                  {alunno.telefono}
                                                </div>
                                                <div className="col-4">
                                                  <strong>Esito </strong>
                                                  {alunno.esito}
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col text-right">
                          <button
                            className={`btn ${hasUnsavedChanges ? "btn-warning" : "btn-primary"}`}
                            onClick={InserisciPresenze}
                          >
                            <svg className="icon icon-white mr-2">
                              <use href={`${iconSprite}#it-check-circle`} />
                            </svg>
                            <span className="text-white">
                              Aggiorna Presenze
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="alert alert-warning mt-5">
                    Nessun alunno{" "}
                    <b>
                      <span className="text-danger">trovato</span>
                    </b>{" "}
                  </div>
                )}
              </>
            )}
          </div>
        ) : (
          <div className="alert alert-warning mt-4 row">
            <div className="col-9">
              <h4>Nessuna versione disponibile</h4>
            </div>
            <div className="col-3 text-right">
              <button
                className="btn btn-outline-primary px-3 ml-1 text-right"
                type="button"
                data-toggle="tooltip"
                data-placement="top"
                onClick={() => setShowModalAdd(true)}
              >
                Aggiungi versione
                <svg className="icon icon-primary">
                  <use href={`${iconSprite}#it-plus`} />
                </svg>
              </button>
            </div>
          </div>
        )}
      </div>
      <ModalComponent
        toggleModal={setShowModalAdd}
        isOpen={showModalAdd}
        header={"Nuova versione"}
        body={
          <>
            <Input
              id="versionName"
              type="text"
              value={versionName}
              onChange={(e) => setVersionName(e.target.value)}
              label="Inserisci il nome della versione"
            />
          </>
        }
        buttonDeny="Chiudi"
        buttonConfirm="Conferma"
        function={() => handleCreateVersion()}
      ></ModalComponent>
      <ModalComponent
        toggleModal={setShowModalModify}
        isOpen={showModalModify}
        header={"Modifica versione"}
        body={
          <>
            <Input
              id="versionName"
              type="text"
              value={versionNameModify}
              onChange={(e) => setVersionNameModify(e.target.value)}
              label="Inserisci il nuovo nome della versione"
            />
          </>
        }
        buttonDeny="Chiudi"
        buttonConfirm="Conferma"
        function={() => handleUpdateVersion()}
      ></ModalComponent>
      <ModalComponent
        toggleModal={setShowModalDel}
        isOpen={showModalDel}
        header={"Elimina versione"}
        body={
          <>
            Sei sicuro di voler eliminare la versione{" "}
            <b>
              {
                listAnnouncementId?.filter(
                  (item) => item.id === localAnnouncementId,
                )[0]?.nome
              }
            </b>
            ? Questa operazione è irreversibile.
          </>
        }
        buttonDeny="Chiudi"
        buttonConfirm="Conferma"
        function={() => handleDeleteVersion()}
      ></ModalComponent>
      <ModalComponent
        toggleModal={setShowModalUpload}
        isOpen={showModalUpload}
        header={"Carica alunni"}
        body={
          <div className="d-flex justify-content-center">
            <UploadFile
              setErrorMessage={setErrorMessage}
              typeFile={["text/csv"]}
              handleFile={setUploadUsersFile}
            ></UploadFile>
          </div>
        }
        buttonDeny="Chiudi"
        buttonConfirm="Conferma"
        function={() => handleUploadAlunni()}
      ></ModalComponent>
      {hasUnsavedChanges && (
        <div className="vm-unsaved-banner">
          <span>
            <strong>⚠ Presenze non salvate</strong> — clicca su &quot;Aggiorna
            Presenze&quot; per confermare le modifiche.
          </span>
          <button
            className="btn btn-warning font-weight-bold px-4 mr-5"
            onClick={InserisciPresenze}
          >
            <svg className="icon icon-white mr-2">
              <use href={`${iconSprite}#it-check-circle`} />
            </svg>
            <span>Aggiorna Presenze</span>
          </button>
        </div>
      )}
      {loading && <Loader />}
    </>
  );
};

export default ViewAlunniMensa;
